module.exports = __webpack_public_path__ + "media/components/src/assets/images/logo/logo-95b9db95db56dc2a6fa87921e814a21e.svg";